module.exports = __webpack_public_path__ + "static/img/top_oiltext.ed7bf8b5.png";